export const environment = {
	production: false,
	// baseUrl: 'http://localhost:3000',
	// imageUrl: 'http://localhost:3000/',
	// previewUrl: 'http://localhost:4200',
	baseUrl: 'https://api.ganjastan.co.uk',
	imageUrl: 'https://api.ganjastan.co.uk/',
	previewUrl: 'https://ganjastan.co.uk',
};
